/**
 * Admin アプリケーションのルートコンポーネント
 */

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { ContactsPage } from "@/features/contacts/pages/contacts-page";
import { BroadcastPage } from "@/features/notifications/pages/broadcast-page";
import { TemplatesPage } from "@/features/templates/pages/templates-page";
import { AdminLayout } from "./admin-layout";
import { AuthGuard } from "./auth-guard";

export function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <AdminLayout>
          <Routes>
            <Route path="/" element={<Navigate to="/contacts" replace />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/contacts/:contactId" element={<ContactsPage />} />
            <Route path="/broadcast" element={<BroadcastPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/templates/:templateId" element={<TemplatesPage />} />
            <Route path="*" element={<Navigate to="/contacts" replace />} />
          </Routes>
        </AdminLayout>
      </AuthGuard>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}
